import { render, staticRenderFns } from "./StoppageReason.vue?vue&type=template&id=cb1f7f38"
import script from "./StoppageReason.vue?vue&type=script&lang=js"
export * from "./StoppageReason.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports